import DOM from '@common/DOM/DOM'
import { wait } from '@common/utils/utils'

import tryToLoad from './tryToLoad'

const DEFAULT_LOAD_WAIT = 500

/**
 * Ez a függvény végzi a konkrét vizsgálatot.
 * @param attr        - Az vizsgált attribútum, default data-src.
 * @param fallbackSrc - A fallback src opcionális.
 */
export default function doLazyLoad (attr = 'data-src', fallbackSrc?: string): void {
  // Az összes elem, aminek van speckó attribútuma
  // Azért containers, mert lehet nem image, hanem div, backgroundImage-el
  const containers: HTMLElement[] = Array.from(document.querySelectorAll(`[${ attr }]`))

  containers.forEach((container) => {
    // Ha látható az elem
    if (DOM.inViewPort(container)) {
      // eslint-disable-next-line no-restricted-syntax -- Jó így.
      wait(DEFAULT_LOAD_WAIT).then(() => {
        tryToLoad(container, attr, fallbackSrc)
      })
    }
  })
}
